import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { toZonedTime } from 'date-fns-tz';
import { timezoneOffsetCalculation } from '../../../utils/timezoneOffsetCalculation';
import { VCS_SLUG } from '../../../constants/api';
import { LoadingMetrics } from './LoadingMetrics';
import PrMetrics from '../../PullRequestsPage/containers/PrMetrics';
import PrList from '../../PullRequestsPage/containers/PrList';
import { CycleTime } from './CycleTime';
import { BasicInfoTemplate } from './BasicInfoTemplate';
import { addMinutes } from 'date-fns';
export const VelocityReportContent = ({ currentNumberOfPRs, previousNumberOfPRs, currentSprint, currentCycleTime, previousCycleTime, dateTimes, datasets, prList, repositories, user, activeRepositoriesIds, from, to, handleRegisterRepo }) => {
    if (!user.user) {
        return _jsx(LoadingMetrics, {});
    }
    const repos = repositories.list[VCS_SLUG[user.user.vcs]] || {};
    const reposSlugs = Object.keys(repos);
    const repositoriesSlugs = Object.assign({}, ...reposSlugs.map((slug) => ({ [repos[slug].id]: slug })));
    let dateFrom, dateTo;
    if (from) {
        dateFrom = addMinutes(toZonedTime(from, 'UTC'), timezoneOffsetCalculation(from, user.user.timezoneId));
    }
    if (to) {
        dateTo = addMinutes(toZonedTime(to, 'UTC'), timezoneOffsetCalculation(to, user.user.timezoneId));
    }
    const basicInfo = {
        previousCycleTime,
        currentCycleTime,
        previousNumberOfPRs,
        currentNumberOfPRs,
    };
    return (_jsxs("div", { className: "velocity", children: [_jsx(BasicInfoTemplate, { basicInfo: basicInfo }), _jsx("hr", {}), _jsx(PrMetrics, { activeRepositoriesIds: activeRepositoriesIds, from: dateFrom, to: dateTo }), _jsx(CycleTime, { currentSprint: currentSprint, previousCycleTime: previousCycleTime, currentCycleTime: currentCycleTime, dateTimes: dateTimes, datasets: datasets }), _jsx(PrList, { pullRequests: prList, repos: repos, repositoriesSlugs: repositoriesSlugs, onRegisterRepo: handleRegisterRepo, gha: !!user.user?.gha })] }));
};
export default VelocityReportContent;
